export enum EDCItemStatus {
  STATUS_AVAILABLE = 'STATUS_AVAILABLE',
  STATUS_AWAITING_UPLOAD = 'STATUS_AWAITING_UPLOAD',
  STATUS_PROCESSING = 'STATUS_PROCESSING',
}

export type EDCItem = { bgColor: string; borderColor: string; color: string; text: string };

export type EDCUploadStatus = { date_uploaded: string; uploaded_by: string };
